const ADD_FORM_VALUES = 'ADD_FORM_VALUES';
const FORM_VALUES_SUBMITTED = 'FORM_VALUES_SUBMITTED';
const SUBMITTED_FAILURE = 'SUBMITTED_FAILURE';
const RESET_FORM_VALUES = 'RESET_FORM_VALUES';

const initialState = {};

export const addFormValuesClient = formValues => dispatch => {
  dispatch({
    type: ADD_FORM_VALUES,
    formValues
  });
  return Promise.resolve();
};

export const resetFormValuesClientAction = () => dispatch => {
  dispatch({
    type: RESET_FORM_VALUES
  });
};

export default function formValuesClientReducer(state = initialState, action) {
  if (action.type === RESET_FORM_VALUES) state = {};

  switch (action.type) {
    case ADD_FORM_VALUES:
      return {
        ...state,
        ...action.formValues
      };
    case FORM_VALUES_SUBMITTED:
      return {
        ...state,
        response: action.response
      };
    case SUBMITTED_FAILURE:
      return {
        ...state,
        error: action.error
      };
    default:
      return state;
  }
}
